export default __webpack_public_path__ + "static/media/ps-create-close.438688c7.svg";